import styled from 'styled-components';

export const StyledHeader = styled.div<{ isMobile: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${({ isMobile }) => isMobile ? 14 : 16}px;
  color: var(${props => props.theme.promptCopyAndSvgColor});

  .headline {
    display: flex;
    align-items: center;
    gap: .5rem;
    justify-content: space-between;
    width: 100%;
  }

  svg {
    height: 28px;
    ${({ isMobile }) => isMobile ? 'height: 24px;' : ''};
    color: var(${props => props.theme.promptCopyAndSvgColor});
  }

  svg.xcover-shield {
    height: 30px;
  }

  .prompt-text {
    font-weight: 600;
    flex-grow: 1;
  }

  .info-icon {
    line-height: 0;

    svg path {
      fill: var(--dark-gray);
    }

    &:focus, &:hover svg path {
      fill: #000000;
    }
  }
`;
